module.exports = __webpack_public_path__ + "img/flow_icon01.46cd9f60.png";